import { Archive } from "@phosphor-icons/react";

import { cn } from "@/lib/utils";

/**
 * Muted flag for a device that a room merge took out of service.
 *
 * Deliberately not amber. `MissingChip` is amber because it marks a gap
 * someone still has to fill; a retired sensor is intentional and complete, so
 * it reads as a note, not a warning.
 */
export function RetiredChip({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "bg-surface-subtle text-muted inline-flex shrink-0 items-center gap-1 rounded-sm px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap",
        className,
      )}
    >
      <Archive weight="light" className="size-3" />
      Retired
    </span>
  );
}
